angular.module('LeasePilot').filter('underscoreToSpace', function() {
  return function(input) {
    return input ? input.replace(/_/g, ' ') : '';
  };
});
